export const SET_URI = 'SET_URI'

export const setUri = (uri) => ({
    type: SET_URI,
    uri,
})
